import PropTypes from 'prop-types';
/**
 * Ensure children are specific React Component or HTML Element types. `false`
 * types allow children to be rendered with inline conditionals,
 * e.g. via `{someValue && <Component />}`
 * See: https://github.com/facebook/react/issues/2979
 *
 * @param {(Class[]|string[]|boolean[])} components array of Components or HTML Element types
 * @returns {PropType}
 */
var oneOfComponentType = function (components) {
    return PropTypes.oneOfType([
        // Either a single component child
        PropTypes.shape({
            type: PropTypes.oneOf(components)
        }),
        PropTypes.oneOf([false]),
        // Or multiple component children
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.shape({
                type: PropTypes.oneOf(components)
            }),
            PropTypes.oneOf([false]),
        ])),
    ]);
};
export default oneOfComponentType;
//# sourceMappingURL=oneOfComponentType.js.map